module.exports = __webpack_public_path__ + "static/media/scanner-touchscreen.7efdf3bb.svg";